import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import previewImg from "../../src_img/preview.png";
// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox/fancybox.css";

// import { Document, Page, pdfjs } from "react-pdf";
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function PdfPreview({
  url,
  imgShow = true,
  img = previewImg,
  title = "Preview",
  divStyle = {
    backgroundColor: "#ffffff",
    color: "#fff",
    margin: "0",
    display: "inline-block",
    padding: "4px",
    border: "none",
    outline: "none",
  },
  imgStyle = { height: "30px" },
}) {
  //   useEffect(() => {
  //     if (window.$ && window.$?.fancybox) {
  //       window.$("[data-fancybox]").fancybox({
  //         hash: false,
  //         iframe: {
  //           preload: true,
  //         },
  //       });
  //     } else {
  //       console.error("Fancybox or jQuery not loaded properly");
  //     }

  //     // Fancybox.bind("[data-fancybox]", {
  //     //   // options here
  //     // });

  //     // return () => {
  //     //   Fancybox.destroy();
  //     // };
  //   }, []);

  return (
    <>
      {/* <a
        data-fancybox
        data-type="iframe"
        data-src={`https://docs.google.com/gview?embedded=true&url=${url}`}
        href="javascript:;"
      >
        {title}
      </a> */}

      <div
        style={divStyle}
        onClick={() => {
          if (window.$ && window.$.fancybox) {
            window.$.fancybox.open({
              src: `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
                url
              )}`,
              type: "iframe",
              iframe: {
                preload: true,
                css: {
                  height: "100%",
                },
              },
            });
          }
        }}
      >
        {imgShow ? <img src={img} style={imgStyle} alt="preview" /> : title}
      </div>
    </>
  );
}

export default PdfPreview;
